// extracted by mini-css-extract-plugin
export default {"wrapper":"IntegrationLoginPage_wrapper__YVnD+","content":"IntegrationLoginPage_content__nevco"};